"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const MemoryFileWidget_ = require("./MemoryFileWidget");
exports.MemoryFileWidget = MemoryFileWidget_;
//# sourceMappingURL=spare fields.js.map


// WEBPACK FOOTER //
// ./build/components/spare fields/spare fields.js